import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  title: ReactNode;
  /** Why it is empty and what would fill it. */
  text?: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
  compact?: boolean;
}

/** Every list has one. Icon, sentence, next action — never a lone grey line. */
export function EmptyState({ title, text, icon, actions, compact }: EmptyStateProps) {
  return (
    <div className={compact ? 'ui-empty ui-empty--compact' : 'ui-empty'}>
      <div className="ui-empty-icon">{icon ?? <Inbox />}</div>
      <div className="ui-empty-title">{title}</div>
      {text && <div className="ui-empty-text">{text}</div>}
      {actions && <div className="ui-empty-actions">{actions}</div>}
    </div>
  );
}
